import React from 'react';
import '../Network2/styles.css';

function Network() {
  return (
    <section className="network" id="network">
      <div className="network-card scroll-reveal">
        <p className="pill">Coastal procurement</p>
        <h2>Built for scale</h2>
        <p>
          A distributed network of coastal hubs, refrigerated fleets, and micro-fulfilment centers
          ensures last-mile freshness in every metro.
        </p>
        <div className="network-stats">
          <div>
            <strong>20,000+ </strong>
            <span>tons moved monthly</span>
          </div>
          <div>
            <strong>48 </strong>
            <span>city fulfilment zones</span>
          </div>
          <div>
            <strong>6 to 12 hrs </strong>
            <span>average dock-to-door</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Network;
